module.exports = __webpack_public_path__ + "img/safety.587469e5.jpg";